module.exports = __webpack_public_path__ + "static/personal_picture-e0796319d22a11c401a3b910292db78f.jpg";